import { Fa1 } from "react-icons/fa6";
import { Fa2 } from "react-icons/fa6";
import { Fa3 } from "react-icons/fa6";
import { Fa4 } from "react-icons/fa6";
import { Fa5 } from "react-icons/fa6";
import { Fa6 } from "react-icons/fa6";
import { GiHealthNormal } from "react-icons/gi";
import { MdDoNotTouch } from "react-icons/md";
import { useLanguage } from "./LanguageContext";


function Aftercare(){
    const {language} = useLanguage();
  return(
    <>
    {language === "en"?(
    <section className="bg-lightBrown px-6 min-h-screen overflow-hidden avenir">
	<div className="container mx-auto flex flex-col p-6">
		<h2 className="py-4 text-3xl font-bold text-center text-darkerCream">AFTER CARE FOR YOUR FESH TATTOO
        </h2>
        <p className="py-4 text-xl font-bold text-center">Caring for and maintaining a tattoo after getting it is very important to ensure good healing and preserve the beauty of the tattoo over time. Below are some basic guidelines for tattoo care:</p>
		<div className="divide-y divide-black">
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
					<Fa1 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>
				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Step 1:</span>
					<span className="mt-4 ">Always keep the tattooed area clean: During the first 24-48 hours after getting the tattoo, keep the area clean and avoid direct contact with water or liquids. After that, you can gently wash the tattooed area with warm water and mild soap to remove oil and dirt. After washing, pat the area dry with a clean, soft towel.
                    </span>
				</div>
			</div>
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa2 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Step 2:</span>
					<span className="mt-4 "> Use antibacterial ointment: After washing and drying the tattooed area, apply a small amount of antibacterial ointment or skincare cream recommended by your tattoo artist. Gently apply the ointment to the tattooed area to keep the skin soft and reduce the risk of infection.</span>
				</div>
			</div>
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa3 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
                <span className="text-xl font-bold md:text-2xl">Step 3:</span>
                <span className="mt-4  "> Avoid harsh rubbing and stretching of the tattooed area: During the healing process, avoid rubbing or stretching the tattooed area. Do not scratch the tattoo, touch it unnecessarily, or let clothing or other objects rub against it.
                    </span>
				</div>
			</div>
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa4 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Step 4:</span>
					<span className="mt-4 ">Avoid exposure to sunlight and ultraviolet (UV) rays: During the healing process, avoid direct exposure to sunlight and UV rays. If you need to go outside, cover the tattooed area with clothing or bandages, and use sunscreen with a high SPF to protect the skin.</span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa5 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Step 5:</span>
					<span className="mt-4 ">Avoid soaking in water and strenuous physical activities: During the healing process, avoid soaking the tattooed area in water (such as pools, hot tubs, or the ocean) and refrain from strenuous physical activities, like exercising or dancing, until the tattoo has fully healed.
                    </span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa6 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
                <span className="text-xl font-bold md:text-2xl">Step 6:</span>
                <span className="mt-4 ">Adjust your diet and exercise routine: To support the healing process, maintain a healthy diet and engage in light exercise. This helps boost the immune system and promotes the body's natural healing.
                    </span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <GiHealthNormal viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Foods to Eat After Getting a Tattoo</span>
					<span className="mt-4 "> 
                    <ol className="list-decimal list-inside space-y-4">
                        <li>Antioxidant-rich foods: Fresh fruits and vegetables provide antioxidants, which boost the immune system and support the healing process. Eat plenty of berries, oranges, kiwis, apples, tomatoes, broccoli, leafy greens, and carrots.
                        </li>
                        <li>Protein-rich foods: Protein plays a vital role in regenerating and building cellular tissues. Include meat, fish, grains, nuts, and legumes in your daily diet.

                        </li>
                        <li>Omega-3 fatty acid-rich foods: Omega-3 fatty acids have anti-inflammatory properties and help soothe the skin. For sources of omega-3, eat fish such as salmon, mackerel, sardines, as well as chia seeds and flaxseeds.

                        </li>
                        <li>Water: Drink enough water to keep your body and skin well-hydrated. Aim to drink at least 8 glasses of water per day.

                        </li>
                        
                    </ol>  
                    </span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <MdDoNotTouch  fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Foods to Limit After Getting a Tattoo</span>
					<span className="mt-4 "> 
                    <ol className="list-decimal list-inside space-y-4">
                        <li>Chicken (can harm the tattoo and cause the ink to fade after healing).
                        </li>
                        <li> Chicken eggs (can cause ink to blur or spread unevenly).
                        </li>
                        <li> Sticky rice (can lead to toxin buildup in the skin after tattooing, and in some cases, may cause pus formation in individuals with sensitive skin).

                        </li>
                        <li> Water spinach (in some cases, it can cause the tattooed areas to develop raised scars over time).


                        </li>
                        <li> Alcohol (thins the blood and stimulates circulation, which can affect the tattoo).



                        </li>
                        <li> Seafood, including shrimp, crab, snails, squid, clams, mussels, and oysters (can cause irritation and redness around the tattoo).
                        </li>
                        
                    </ol>  
                    </span>
				</div>
			</div>
		</div>
	</div>
</section>
    ):(
    <section className="bg-lightBrown px-6 min-h-screen overflow-hidden avenir">
	<div className="container mx-auto flex flex-col p-6">
		<h2 className="py-4 text-3xl font-bold text-center text-darkerCream">CHĂM SÓC HÌNH XĂM SAU KHI XĂM
        </h2>
        <p className="py-4 text-xl font-bold text-center">Chăm sóc và bảo dưỡng hình xăm sau khi xăm là rất quan trọng để đảm bảo quá trình lành tốt và giữ vẻ đẹp của hình xăm trong thời gian dài. Dưới đây là một số hướng dẫn cơ bản để chăm sóc hình xăm:</p>
		<div className="divide-y divide-black">
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
					<Fa1 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>
				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Bước 1:</span>
					<span className="mt-4 ">Luôn giữ vùng xăm sạch: Trong 24-48 giờ đầu sau khi xăm, hãy giữ vùng xăm sạch sẽ và không để nước hoặc chất lỏng tiếp xúc trực tiếp với nó. Sau đó, bạn có thể rửa vùng xăm nhẹ nhàng bằng nước ấm và xà phòng nhẹ để loại bỏ chất nhờn và bụi bẩn. Sau khi rửa, hãy lau khô vùng xăm bằng một khăn sạch và mềm.
                    </span>
				</div>
			</div>
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa2 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Bước 2:</span>
					<span className="mt-4 "> Sử dụng kem mỡ chống vi khuẩn: Sau khi rửa và lau khô vùng xăm, hãy áp dụng một lượng nhỏ kem mỡ chống vi khuẩn hoặc kem chăm sóc da được khuyến nghị bởi nghệ sĩ xăm hình của bạn. Thoa kem mỡ nhẹ nhàng lên vùng xăm để giữ cho da mềm mịn và giảm nguy cơ nhiễm trùng.</span>
				</div>
			</div>
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa3 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
                <span className="text-xl font-bold md:text-2xl">Bước 3:</span>
                <span className="mt-4  "> Tránh chà xát mạnh và kéo căng vùng xăm: Trong quá trình hồi phục, hãy tránh chà xát mạnh hoặc kéo căng vùng xăm. Đừng cào vùng xăm, không đụng tay vào nó nếu không cần thiết và không để quần áo hay vật cản khác cọ vào vùng xăm.
                    </span>
				</div>
			</div>
			<div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa4 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Bước 4:</span>
					<span className="mt-4 ">Tránh tiếp xúc với ánh nắng mặt trời và tia cực tím: Trong suốt quá trình lành, hãy tránh tiếp xúc trực tiếp với ánh nắng mặt trời và tia cực tím. Nếu bạn phải ra ngoài, hãy che chắn vùng xăm bằng quần áo hoặc băng bó, và sử dụng kem chống nắng có SPF cao để bảo vệ da.</span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa5 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Bước 5:</span>
					<span className="mt-4 ">Tránh ngâm nước và hoạt động vật lý căng thẳng: Trong suốt quá trình lành, tránh ngâm vùng xăm trong nước (như bể bơi, bồn tắm nóng, hoặc biển) và tránh hoạt động vật lý căng thẳng, như tập thể dục hoặc nhảy nhót, cho đến khi vùng xăm đã hoàn toàn lành.
                    </span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <Fa6 viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
                <span className="text-xl font-bold md:text-2xl">Bước 6:</span>
                <span className="mt-4 ">Điều chỉnh chế độ ăn uống và tập thể dục: Để hỗ trợ quá trình lành, hãy duy trì một chế độ ăn uống lành mạnh và tập thể dục nhẹ nhàng. Điều này giúp tăng cường hệ miễn dịch và thúc đẩy quá trình lành lành của cơ thể.
                    </span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <GiHealthNormal viewBox="0 0 512 512" fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Những Thực Phẩm Nên Dùng Sau Khi Xăm</span>
					<span className="mt-4 "> 
                    <ol className="list-decimal list-inside space-y-4">
                        <li>Thực phẩm giàu chất chống oxy hóa: Trái cây và rau xanh tươi cung cấp chất chống oxy hóa, giúp tăng cường hệ miễn dịch và hỗ trợ quá trình lành. Hãy ăn nhiều quả mọng, cam, kiwi, táo, cà chua, cải xanh, rau cải, và cà rốt.
                        </li>
                        <li>Thực phẩm giàu protein: Protein là yếu tố quan trọng trong việc tái tạo và xây dựng mô tế bào. Hãy bao gồm thịt, cá, ngũ cốc, hạt, đậu vào chế độ ăn hàng ngày của bạn.

                        </li>
                        <li>Thực phẩm giàu axit béo omega-3: Axit béo omega-3 có tác dụng chống viêm và làm dịu da. Đối với nguồn cung cấp omega-3, hãy ăn cá như cá hồi, cá mackerel, cá sardine, hạt chia, và hạt lanh.

                        </li>
                        <li>Nước: Uống đủ nước để giữ cho cơ thể và da của bạn được cung cấp đủ độ ẩm. Hãy uống ít nhất 8 ly nước mỗi ngày.

                        </li>
                        
                    </ol>  
                    </span>
				</div>
			</div>
            <div className="grid justify-center grid-cols-4 p-8 mx-auto space-y-8 lg:space-y-0">
				<div className="flex items-center justify-center lg:col-span-1 col-span-full">
                <MdDoNotTouch  fill="currentColor" className="w-16 h-16"/>

				</div>
				<div className="flex flex-col justify-center max-w-3xl text-center col-span-full lg:col-span-3 lg:text-left">
					<span className="text-xl font-bold md:text-2xl">Những Thực Phẩm Cần Hạn Chế Sau Khi Xăm</span>
					<span className="mt-4 "> 
                    <ol className="list-decimal list-inside space-y-4">
                        <li>Thịt gà ( gây độc cho hình xăm và làm mờ nhạt sắc độ mực sau khi lành )

                        </li>
                        <li> Trứng gà ( dễ gây loang trắng mực xăm, không đều mực )


                        </li>
                        <li> Xôi nếp ( dễ gây tích tụ độc tố cho da sau xăm, một số trường hợp cơ địa không tốt sẽ gây mưng mủ )

                        </li>
                        <li> Rau muống ( một số trường hợp sẽ gây lồi các vết xăm sau một thời gian lành )


                        </li>
                        <li> Bia rượu ( gây loãng máu, kích thích tuần hoàn máu ảnh hưởng đến hình xăm )



                        </li>
                        <li> Hải sản bao gồm tôm, cua, ốc, mực, ngêu, sò, hàu...( gây kích ứng, mẫn đỏ xung quanh hình xăm )



                        </li>
                        
                    </ol>  
                    </span>
				</div>
			</div>
		</div>
	</div>
</section>
    )}
    </>
  )
}

export default Aftercare